import React from 'react';
import '../../styles/form.css';

export default function Card({ children, className = '', ...props }) {
    return (
        <div className={`card ${className}`} {...props}>
            {children}
        </div>
    );
}
